import { reatomAsync, withAbort } from '@reatom/async';
import { atom } from '@reatom/framework';
import { BACKEND_API, CartItem, type CartItemRequest } from '@trwl/backend.api';
import { StoreProduct } from '@trwl/entities/product/@x';
import { cartAtom } from '@trwl/store';

export const loadCartAction = reatomAsync((ctx) => {
  return BACKEND_API.CartApi.getCartItems({
    signal: ctx.controller.signal,
  }).then((r) => {
    const data: StoreProduct[] = r.data.map((item) => {
      const productDeliveryType = item.product?.productDeliveryTypes?.find(
        (t) => t.deliveryType === item.deliveryType,
      );
      return {
        url: item.variant && `/product/${item.variant.productId}`,
        id: item.variantId,
        deliveryAmount: productDeliveryType?.amount ?? 0,
        deliveryType: item.deliveryType,
        properties: item.variant?.saleProperties.map((s) => ({
          key: s.propertyName,
          value: s.propertyValue,
        })),
        count: item.count,
        name: item.product?.title || '',
        image: item.product?.logoUrl || '',
        price: item.variant?.price || 0,
        added_at: Date.now(),
        minDelivery: item.variant?.minDelivery,
        maxDelivery: item.variant?.maxDelivery,
      };
    });
    cartAtom(ctx, data);
  });
}, 'loadCartAction').pipe(withAbort());

export const isCartLoadingAtom = atom(
  (ctx) => ctx.spy(loadCartAction.pendingAtom) > 0,
  'isCartLoadingAtom',
);

export const saveCartItemsAction = reatomAsync(
  async (ctx, data: CartItemRequest) => {
    return BACKEND_API.CartApi.saveCartItems(data, {
      signal: ctx.controller.signal,
    });
  },
  'saveCartItemsAction',
).pipe(withAbort());

export const deleteCartItemAction = reatomAsync(async (ctx, data: CartItem) => {
  return BACKEND_API.CartApi.deleteCartItem(data, {
    signal: ctx.controller.signal,
  });
}, 'deleteCartItemAction').pipe(withAbort());
